export default function getUnusedHoverPopulation({
  combatants = [],
  currentAction = 0,
  maxCA = 0,
  extraAttacksMode = false,
} = {}) {
  const activeCombatants = combatants.filter((combatant) => combatant?.status === 'Active')

  if (extraAttacksMode) {
    const extraAction = Number(maxCA || 0) + 1
    const extraSlugField = `ca_slug${extraAction}`

    return activeCombatants.filter(
      (combatant) => combatant?.extra === true || (combatant?.[extraSlugField] ?? '') !== '',
    ).length
  }

  const resolvedCurrentAction = Number(currentAction || 0)

  if (resolvedCurrentAction <= 0) {
    return 0
  }

  return activeCombatants.filter((combatant) => {
    const actionName = combatant?.[`ca_name${resolvedCurrentAction}`]
    return actionName !== 'blank' && actionName !== '' && actionName != null
  }).length
}
